import React from 'react'
import './index.css'
import { Row, Col, Flex, Typography, Card, Rate, Avatar, List, Tooltip, Image } from 'antd'
import Slider from 'react-slick';
import {LeftOutlined,RightOutlined , BulbOutlined, HeartOutlined, EyeOutlined, MehOutlined } from '@ant-design/icons';
const { Title, Text, Paragraph } = Typography

const Recommendedcourses = () => {
    const CustomPrevArrow = (props) => {
        const { className, style, onClick } = props;
        return (
            <LeftOutlined 
                className={className} 
                style={{ 
                    ...style, 
                    color: '#fff', 
                    fontSize: '24px',
                    zIndex: 1,
                    left: '-40px',  // Adjust position
                    position: 'absolute',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer'
                }} 
                onClick={onClick} 
            />
        );
    };
    
    const CustomNextArrow = (props) => {
        const { className, style, onClick } = props;
        return (
            <RightOutlined 
                className={className} 
                style={{ 
                    ...style, 
                    color: '#fff',
                    fontSize: '24px',
                    zIndex: 1,
                    right: '-40px', // Adjust position
                    position: 'absolute',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer'
                }} 
                onClick={onClick} 
            />
        );
    };

    const testimonialData = [
        {
            key: '1',
            userimg: 'av-1.png',
            username: 'Radionov R. added a photo',
            posttime: '1 minute ago',
            cardimg: 'minipotstickers.jpg',
            cardtitle: 'Mini Potstickers',
            carddesc: 'I accidentally stumbled upon framer while looking for another tool but I am very glad I did!.'
        },
        {
            key: '2',
            userimg: 'av-1.png',
            username: 'Radionov R. added a photo',
            posttime: '1 minute ago',
            cardimg: 'pakwan.jpg',
            cardtitle: 'Pakwan Restaurant',
            carddesc: 'I accidentally stumbled upon framer while looking for another tool but I am very glad I did!.'
        },
        {
            userimg: 'av-1.png',
            username: 'Radionov R. added a photo',
            posttime: '1 minute ago',
            cardimg: 'honor-kitchen.jpg',
            cardtitle: 'Honor Kitchen & Cocktails',
            carddesc: 'I accidentally stumbled upon framer while looking for another tool but I am very glad I did!.'
        },
        {
            userimg: 'av-1.png',
            username: 'Radionov R. added a photo',
            posttime: '1 minute ago',
            cardimg: 'samara.jpg',
            cardtitle: 'Samara Southern Creations',
            carddesc: 'I accidentally stumbled upon framer while looking for another tool but I am very glad I did!.'
        },
    ]

    var testimonialSlider = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 0
                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 0
                }
            }
        ]
    }

    return (
        <div className='padding-main'>
            <div className='container'>
                <Row gutter={[24, 24]}>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                        <Flex vertical align='center'>
                            <Title level={1} className='m-0 brown-gadient'>
                                Recommended Courses
                            </Title>
                        </Flex>
                    </Col>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                        <Slider {...testimonialSlider}>
                            {
                                testimonialData?.map((data, index) => {
                                    return (
                                        <div className='px-2'>
                                            <Card className='bg-transparent border-gray product-card shadow-c border0 rounded0' style={{ padding: '0px !important' }} key={index} actions={[
                                                <Tooltip title="Help">
                                                    <Image src={'assets/icons/bulb.svg'} width={20} preview={false}></Image>
                                                </Tooltip>,
                                                <Tooltip title="Thanks">
                                                   <Image src={'assets/icons/hands.svg'} width={20} preview={false}></Image>
                                                </Tooltip>,
                                                <Tooltip title="Love This">
                                                    <Image src={'assets/icons/heart.svg'} width={20} preview={false}></Image>
                                                </Tooltip>,
                                                <Tooltip title="Oh no">
                                                    <Image src={'assets/icons/emoji.svg'} width={20} preview={false}></Image>
                                                </Tooltip>
                                            ]}>
                                                <List itemLayout="horizontal" className='m-0 px-2' style={{ padding: "0px !important" }}>
                                                    <List.Item>
                                                        <List.Item.Meta
                                                            avatar={<Avatar src={'/assets/images/' + data?.userimg} />}
                                                            title={<Title level={5} className='m-0 fw-400'>{data?.username}</Title>}
                                                            description={<Text className='m-0'>{data?.posttime}</Text>}
                                                        />
                                                    </List.Item>
                                                </List>
                                                <Flex vertical gap={20}>
                                                    <img src={'/assets/images/' + data?.cardimg} width={'100%'} height={'200px'} />
                                                    <Flex vertical gap={5} className='px-2'>
                                                    <Title level={5} className='m-0'>
                                                        {
                                                            data?.cardtitle
                                                        }
                                                    </Title>
                                                    <Rate defaultValue={5} />
                                                    <Paragraph
                                                            ellipsis={{
                                                            rows: 2,
                                                                expandable: true,
                                                            }}
                                                            title={data?.carddesc}
                                                            className='overflow-on m-0'
                                                        >
                                                            {data?.carddesc}
                                                        </Paragraph>
                                                    </Flex>
                                                </Flex>
                                            </Card>
                                        </div>
                                    )
                                })
                            }
                        </Slider>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export { Recommendedcourses }